import React, { Component } from "react";
import axios from "axios";
import * as appConst from "../../../Common/constants";
import ReceiptEntry from "./Report.ReceiptEntry";

var convertRupeesIntoWords = require("convert-rupees-into-words");

class ReceiptMultiple extends Component {
  constructor(props) {
    super(props);

    this.state = {
      _id: "",
      name: "",
      date: "",
      receiptNo: "",
      desc: "",
      type: "",
      amount: 0,
      txnType: "",
      receipts: [],
      receipt: ""
    };
  }

  componentDidMount() {
    axios
      .post(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +   "/account/receiptDetails",
        this.props.data
      )
      .then(response => {
        if (this.props.data.count === 1) {
          var obj = response.data;
          var arr = obj.txndate.split("-");

          var amtWords;
          if (obj.amount < 0)
            amtWords = convertRupeesIntoWords(obj.amount * -1);
          else amtWords = convertRupeesIntoWords(obj.amount);

          const data = {
            _id: obj._id,
            name: obj.name,
            date: arr[2].substring(0, 2) + "-" + arr[1] + "-" + arr[0],
            receiptNo: obj.receiptNo,
            desc: obj.desc,
            type: obj.type,
            amount: obj.amount,
            txntype: obj.txntype,
            amountWords: amtWords
          };
          this.setState({ receipt: data });
        } else {
          response.data.map(obj => {
            var amtWords;
            if (obj.amount < 0)
              amtWords = convertRupeesIntoWords(obj.amount * -1);
            else amtWords = convertRupeesIntoWords(obj.amount);

            var arr = obj.txndate.split("-");
            const data = {
              _id: obj._id,
              name: obj.name,
              date: arr[2].substring(0, 2) + "-" + arr[1] + "-" + arr[0],
              receiptNo: obj.receiptNo,
              desc: obj.desc,
              type: obj.type,
              amount: obj.amount,
              txntype: obj.txntype,
              amountWords: amtWords
            };
            this.setState(previousState => ({
              receipts: [...previousState.receipts, data]
            }));
          });
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  render() {
    return <div className="p-5">{this.RenderReceipt()}</div>;
  }

  RenderReceipt() {
    if (this.props.data.count === 1) {
      return (
        <ReceiptEntry key={this.state.receipt._id} data={this.state.receipt} />
      );
    } else {
      return this.state.receipts.map(obj => {
        return <ReceiptEntry key={obj._id} data={obj} />;
      });
    }
  }
}

export default ReceiptMultiple;
